import { Routes, Route } from 'react-router-dom'
import { SessionProvider } from './contexts/SessionContext'
import HomePage from './pages/HomePage'
import LoginPage from './pages/LoginPage'
import LoginVerifyPage from './pages/LoginVerifyPage'
import LoginMagicLinkPage from './pages/LoginMagicLinkPage'
import LoginErrorPage from './pages/LoginErrorPage'
import IntegrationsPage from './pages/IntegrationsPage'
import IntegrationSecretsPage from './pages/IntegrationSecretsPage'
import ReportsPage from './pages/ReportsPage'
import CreditReportPage from './pages/CreditReportPage'
import HardpullReportPage from './pages/HardpullReportPage'
import PrequalificationPage from './pages/PrequalificationPage'
import PrequalificationCompletePage from './pages/PrequalificationCompletePage'
import AdminInvitationsPage from './pages/AdminInvitationsPage'
import PrivateRoute from './components/PrivateRoute'
import IntegratorDocsFab from './components/IntegratorDocsFab'

function App() {
  return (
    <SessionProvider>
      <IntegratorDocsFab />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/login/verify" element={<LoginVerifyPage />} />
        <Route path="/login/magic-link" element={<LoginMagicLinkPage />} />
        <Route path="/login/error" element={<LoginErrorPage />} />
        <Route path="/prequalification/:requestId" element={<PrequalificationPage />} />
        <Route path="/prequalification/:requestId/complete" element={<PrequalificationCompletePage />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <HomePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/integrations"
          element={
            <PrivateRoute roles={['administrator', 'integrator']}>
              <IntegrationsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/integrations/:integrationId/secrets"
          element={
            <PrivateRoute roles={['administrator', 'integrator']}>
              <IntegrationSecretsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <PrivateRoute>
              <ReportsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/credit-reports/:id"
          element={
            <PrivateRoute>
              <CreditReportPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/hardpull/reports/:id"
          element={
            <PrivateRoute>
              <HardpullReportPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/invitations"
          element={
            <PrivateRoute roles={['administrator']}>
              <AdminInvitationsPage />
            </PrivateRoute>
          }
        />
      </Routes>
    </SessionProvider>
  )
}

export default App

